import type { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles';
import { boxShadow } from '../global/shadows';

export const MuiFab = (theme: Theme): Components => ({
  MuiFab: {
    styleOverrides: {
      root: {
        ...theme.typography.h6,
        fontSize: theme.typography.pxToRem(15),
        '& .MuiBadge-root': {
          marginRight: 18,
        },
        '& svg:not(.MuiBadge-root svg)': {
          marginLeft: 27,
        },
        boxShadow: boxShadow.large,
        '&:hover': {
          backgroundColor: theme.palette.primary.light,
        },
        '&:active': {
          backgroundColor: theme.palette.primary.dark,
        },
        '&:focus-visible': {
          backgroundColor: theme.palette.primary.dark,
        },
      },
      extended: {
        padding: '12px 24px',
        minHeight: 54,
        borderRadius: 50,
      },
    },
    defaultProps: {
      variant: 'extended',
      color: 'primary',
    },
  },
});
